<template>
  <div class="simple-card__content p-md-3">
    <a
      ref="title"
      class="card__title mb-2 font-weight-bold"
      data-line-clamp="1"
      :href="content.url"
    >
      {{ processedContent.title }}
    </a>

    <a
      v-for="genre in processedContent.genres"
      :key="genre.id"
      :href="genre.url"
      class="genre-block d-none d-sm-inline-block"
      data-event-category="discover"
      data-event-action="info"
      :data-event-label="genre.name"
    >
      {{ genre.name }}
    </a>

    <div
      v-if="processedContent.reviewScore || processedContent.rating || processedContent.languages.length > 0"
      class="mt-2 d-none d-sm-block"
    >
      <img
        v-show="processedContent.reviewScore"
        :style="{'vertical-align': 'unset'}"
        src="@/images/star.png"
        alt="review-star-icon"
        width="12"
        height="12"
      >
      <span class="font-weight-bold">
        {{ processedContent.reviewScore }}
        {{ (processedContent.rating && processedContent.reviewScore) && '|' }}
        {{ processedContent.rating }}
        {{ (processedContent.rating || processedContent.reviewScore) && processedContent.languages.length > 0 ? '|' :'' }}
        {{ processedContent.languages.join(', ') }}
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import markupHelper from '@/scripts/helpers/markup-helper';
import truncate from '@/scripts/helpers/truncate-helper';

import { SimpleContentCompat } from '@/scripts/models/CardInfoCompat/ContentCardCompat';

export default Vue.extend({
  props: {
    content: {
      type: Object as PropType<SimpleContentCompat>,
      required: true,
    },
  },
  computed: {
    processedContent(): Required<SimpleContentCompat> {
      return {
        title: markupHelper.stripTags(this.content.title || ''),
        genres: this.content.genres || [],
        rating: this.content.rating || '',
        languages: this.content.languages || [],
        reviewScore: this.content.reviewScore || '',
      };
    },
  },
  mounted() {
    truncate.truncate(this.$refs.description);
    truncate.truncate(this.$refs.title);
  },
});
</script>

<style lang="scss">

.genre-block {
  background-color: #d82B6a;
  color: white;
  border-radius: 4px;
  padding: 4px 8px;
  margin-right: 8px;
  font-size:12px;
}

.content-block {
  margin-top: 20px 0
}
.genre-block:hover{
    color: white !important;
}

</style>
